import { SectionSubtitle, SectionTitle } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { facebook, instagram, socialsDecorationImages } from './assets';
import * as Styled from './styled';
import type { SocialsSectionProps } from './types';

export * from './types';

export const SocialsSection: FC<SocialsSectionProps> = (props) => {
  const { ...rest } = props;

  const { translate: translateRessource } = useTranslation({
    keyPrefix: 'common.sections.socials',
  });

  return (
    <Styled.Wrapper {...rest}>
      <SectionTitle color="purple">{translateRessource('title')}</SectionTitle>
      <SectionSubtitle>{translateRessource('subtitle')}</SectionSubtitle>
      <Styled.IconContainer>
        <Styled.IconWrapper href="https://www.instagram.com/tipawdogs/" target="_blank">
          <Styled.Icon src={instagram} alt="instagram icon" />
        </Styled.IconWrapper>
        <Styled.IconWrapper href="https://www.facebook.com/tipawdogs/" target="_blank">
          <Styled.Icon src={facebook} alt="facebook icon" />
        </Styled.IconWrapper>
      </Styled.IconContainer>
      <Styled.ImageContainer>
        {socialsDecorationImages.map((item, index) => (
          <Styled.Image
            key={index}
            src={item.image}
            style={{
              width: item.width,
              height: item.heigth,
            }}
            alt="socials decoration image"
          />
        ))}
      </Styled.ImageContainer>
    </Styled.Wrapper>
  );
};
